import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../lib/auth";
import { PetlocMark } from "./PetlocMark";

export function PublicLayout({
  children,
  variant = "default",
}: {
  children: React.ReactNode;
  variant?: "default" | "center";
}) {
  const { t } = useTranslation();
  const { me } = useAuth();

  return (
    <div className="min-h-dvh flex flex-col bg-[#FBF8F5]">
      <header className="bg-white/80 backdrop-blur-sm border-b border-[#ECE3E7]">
        <div className="mx-auto max-w-5xl flex items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center gap-[11px] no-underline text-[#1B0E16]">
            <span className="text-brand-600"><PetlocMark size={34} /></span>
            <span className="font-display text-lg font-medium">{t("app.name")}</span>
          </Link>
          <div className="flex items-center gap-2">
            {me ? (
              <Link to="/app" className="btn-primary">
                {t("nav.dashboard")}
              </Link>
            ) : (
              <>
                <Link to="/login" className="btn-ghost">
                  {t("nav.login")}
                </Link>
                <Link to="/signup" className="btn-primary">
                  {t("nav.signup")}
                </Link>
              </>
            )}
          </div>
        </div>
      </header>

      <main
        className={
          variant === "center"
            ? "flex-1 flex items-center justify-center px-4 py-8"
            : "flex-1"
        }
      >
        {children}
      </main>

      <footer className="border-t border-[#ECE3E7] py-8 text-center text-sm text-[#8A7A82]">
        <div className="flex flex-wrap justify-center gap-4 mb-3">
          <Link to="/katze-vermisst">Katze vermisst – was tun?</Link>
          <Link to="/qr-anhaenger-vs-tasso-gps">QR-Anhänger vs. Tasso vs. GPS</Link>
        </div>
        <div className="flex flex-wrap justify-center gap-4">
          <Link to="/impressum">{t("legal.impressum")}</Link>
          <Link to="/datenschutz">{t("legal.datenschutz")}</Link>
          <Link to="/agb">{t("legal.agb")}</Link>
        </div>
        <div className="mt-4 flex items-center justify-center gap-2">
          <span className="text-brand-600"><PetlocMark size={20} /></span>
          <span>© {new Date().getFullYear()} petloc</span>
        </div>
      </footer>
    </div>
  );
}
